import React, { useState } from 'react'
import { Flex, MainHeadline, PageWrapper, PageFooter } from '../../styling/GlobalStyles'
import { Button } from 'components/ui/Button/Button'
import { NavBar } from '../../components/NavBar/NavBar'
import { StatusPill } from 'components/ui/StatusPill/StatusPill'
import { useNavigate } from 'react-router-dom'
import { ITaskTemplate } from 'types/task-templates.interface'
import { IGetAllTaskTemplatesSingleResponse } from 'types/api/tasksTemplatesApi.interface'
import { useDispatch, useSelector } from 'react-redux'
import { clearTaskTemplatesList, deleteTaskTemplate, duplicateTaskTemplate, getTaskTemplates } from 'features/taskTemplates/taskTemplatesSlice'
import { AppDispatch, RootState } from 'store'
import { setConfirmModal } from 'features/global/globalSlice'
import { Pagination } from 'components/Pagination/Pagination'
import { getParams, handlePagination } from 'utils/helpers'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { ModalTypes } from 'types/global.interface'
import { tokens } from 'styling/tokens'
import { HonestTable, IHonestTableColumn, IHonestTableMenuOption } from 'components/HonestTable/HonestTable'
import useQueryPagination from 'hooks/useQueryPagination'

export const TaskTemplates = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch<AppDispatch>()
  const { allTaskTemplates, totalPages, noTaskTemplates } = useSelector((store: RootState) => store.taskTemplates)
  const [params, setParams] = useState<any>(getParams({ location, limit: 10, ap: { sd: 'a', s: 'displayName' } }))

  useQueryPagination({ fetchFunctions: [getTaskTemplates], cleanUpFunctions: [clearTaskTemplatesList], params })

  const handleDeleteTask = (id: number) => {
    dispatch(
      setConfirmModal({
        isOpen: true,
        onSave: async () => {
          await dispatch(deleteTaskTemplate(id))
        },
        setParams: {
          type: ModalTypes.Delete,
          f: setParams,
          noItems: allTaskTemplates.length < 2,
        },
        word: 'delete task template',
      }),
    )
  }

  const handleDuplicate = (item: ITaskTemplate) => {
    dispatch(duplicateTaskTemplate({ name: item.name + ' copy', taskTemplateId: item.id }))
  }

  const columns: IHonestTableColumn<any>[] = [
    {
      id: 'name',
      header: 'Template',
      cell: (item) => item.name,
    },
    {
      id: 'design',
      header: 'Design',
      cell: (item) => {
        const hasDesign = item?.components || Array.isArray(item.components)
        return <StatusPill status={hasDesign ? 'success' : 'danger'}>{hasDesign ? 'Yes' : 'No'}</StatusPill>
      },
    },
    {
      id: 'logic',
      header: 'Logic',
      cell: (item) => (
        <StatusPill status={item?.isLogicAdded ? 'success' : 'danger'}>{item?.isLogicAdded ? 'Yes' : 'No'}</StatusPill>
      ),
    },
  ]

  const menuOptions: IHonestTableMenuOption<any>[] = [
    { label: 'Edit', onClick: (item) => navigate(item.id + '/edit') },
    { label: 'Delete', color: tokens.status.danger.fg, onClick: (item) => handleDeleteTask(item.id) },
    { label: 'Duplicate', onClick: (item) => handleDuplicate(item) },
  ]

  return (
    <>
      <NavBar defaultValue={params.q} input placeholder='Search Task Templates...' setParams={setParams} limit={10} />
      <PageWrapper>
        <Flex between center mb='16' >
          <MainHeadline>Task Templates</MainHeadline>
          <Button variant='primary' onClick={() => navigate('add')}>
            Add
          </Button>
        </Flex>
        {noTaskTemplates || !allTaskTemplates?.length ? (
          <NoItems title='Task templates' />
        ) : (
          <HonestTable
            columns={columns}
            data={allTaskTemplates as IGetAllTaskTemplatesSingleResponse[]}
            keyField='id'
            onClick={(item) => navigate(item.id + '/edit')}
            menuOptions={menuOptions}
          />
        )}
      </PageWrapper>
      <PageFooter>
        <Pagination
          setPage={(page) => handlePagination(page, setParams, 10)}
          pageCount={Math.ceil(totalPages)}
          forcePage={(params.page ? params.page : 1) - 1}
        />
      </PageFooter>
    </>
  )
}
